// Analytics — GA4 (gtag) + Meta Pixel (fbq)
// Both loaders are no-ops unless the corresponding env var is set,
// so local/preview runs stay silent.

const GA4_ID = (process.env.REACT_APP_GA4_ID || "").trim();
const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();

let inited = false;

function loadScript(src, id, onload) {
  if (document.getElementById(id)) return onload && onload();
  const s = document.createElement("script");
  s.src = src;
  s.async = true;
  s.id = id;
  if (onload) s.onload = onload;
  document.head.appendChild(s);
}

export function initAnalytics() {
  if (inited || typeof window === "undefined") return;
  inited = true;

  // ---- GA4 (gtag.js) ----
  if (GA4_ID) {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line func-names
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: true });
    loadScript(
      `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA4_ID)}`,
      "ga4-script"
    );
  }

  // ---- Meta Pixel (fbq) ----
  if (PIXEL_ID) {
    // Standard Meta Pixel bootstrap
    // eslint-disable-next-line
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.id = "meta-pixel";
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

/**
 * Fire a single named event to any configured provider.
 * @param {string} name      Snake_case event name for GA4 (also used as the Meta custom event name if `metaStandard` is not set)
 * @param {object} params    Optional key/value payload (numbers, strings, booleans)
 * @param {string} metaStandard  Optional Meta *standard* event name (e.g. "Lead", "Contact") — if set, we also fire trackCustom
 */
export function trackEvent(name, params = {}, metaStandard = null) {
  try {
    if (typeof window === "undefined") return;
    // Console breadcrumb for local dev / debugging
    // eslint-disable-next-line no-console
    if (!GA4_ID && !PIXEL_ID) console.debug("[analytics]", name, params);

    if (window.gtag && GA4_ID) {
      window.gtag("event", name, params);
    }
    if (window.fbq && PIXEL_ID) {
      if (metaStandard) window.fbq("track", metaStandard, params);
      window.fbq("trackCustom", name, params);
    }
  } catch (e) {
    // never crash the UI over analytics
    // eslint-disable-next-line no-console
    console.warn("analytics error", e);
  }
}
